import { combineReducers } from 'redux';

import isLoading from './isLoading';
import isOpen from './isOpen';
import params from './params';

export default combineReducers({
  isOpen,
  isLoading,
  params,
});
